import { ConfigProvider } from 'antd';

const getThemeColor = (cssVarName, fallback) => {
  if (typeof window === 'undefined') {
    return fallback;
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(cssVarName)
    .trim();

  return value || fallback;
};

const RadioConfigProvider = ({ children, whiteTheme = false }) => {
  const white = getThemeColor('--color-white', '#ffffff');
  const tertiaryBlue = getThemeColor('--color-tertiary-blue', '#004677');
  const color = whiteTheme ? white : tertiaryBlue;

  return (
    <ConfigProvider
      theme={{
        components: {
          Radio: {
            colorPrimary: color, // Checked box background
            colorPrimaryHover: color, // Hover color
            colorPrimaryBorder: color, // Border color
          },
        },
      }}>
      {children}
    </ConfigProvider>
  );
};

export default RadioConfigProvider;
